module.exports = __webpack_public_path__ + "img/grey_010.7e66b98c.png";